import React from 'react';
import { Carrier } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { createStyles } from './styles';

export interface BookmarkedPlanCardProps {
  portfolioName: string;
  carrier: Carrier;
}

const BookmarkedPlanCard = ({ portfolioName, carrier }: BookmarkedPlanCardProps): JSX.Element => {
  const classes = createStyles();
  return (
    <div className={classes.portfolioCard}>
      <h3 className={classes.portfolioName}>{portfolioName}</h3>
      <img src={carrier?.logo} alt={carrier?.name} className={classes.logo} />
    </div>
  );
};

export default BookmarkedPlanCard;
